import {Separator} from 'platform/components';
import {Box, HStack, Text} from 'platform/foundation';

import {suffixTestId, TestIdProps} from 'shared/web';

interface SeparatorWithLabelProps extends TestIdProps {
  label: string;
}

export function SeparatorWithLabel(props: SeparatorWithLabelProps) {
  return (
    <HStack align="center" spacing={2}>
      <Box>
        <Text
          color="secondary"
          size="small"
          alternative
          noWrap
          data-testid={suffixTestId('separatorWithLabel', props)}
        >
          {props.label}
        </Text>
      </Box>
      <Separator
        orientation="horizontal"
        spacing={0}
        data-testid={suffixTestId('separatorWithLabel', props)}
      />
    </HStack>
  );
}
